import { Component, OnInit, Input, Output, EventEmitter}                                                from "@angular/core";
import { Router }                                                                                       from "@angular/router";
import { NgForm }                                                                                       from "@angular/forms";
import { EmailTemplate }                                                                         from "../../../../models";
import { EmailTemplatesService }                                                                              from "../emailTemplates.service";
import * as swal                                                                                        from "sweetalert2";

@Component({
    selector: "emailTemplateEdit-component",
    template: require("./emailTemplateEdit.component.html"),
    styles: [require("./emailTemplateEdit.component.less").toString()],
    providers: [EmailTemplatesService]
})

export class EmailTemplateEditComponent implements OnInit {
    @Input() emailTemplate: EmailTemplate;
    @Output() saveSuccessful: EventEmitter<any> = new EventEmitter();
    errorMessage: string;
    errors: Error[];
    isProcessing: boolean;
    appAccessForm: NgForm;
    formInvalid: boolean;
    contentTypeValues: any;

    constructor(private cecRouter: Router, private emailTemplateService: EmailTemplatesService) {
        this.contentTypeValues = [
            { value: "HTML", label: "HTML" },
            { value: "Text", label: "Text" }
        ];
    }

    get templateType() {
        let isHtml = this.emailTemplate ? this.emailTemplate.isHtml : false;
        return isHtml ? "HTML" : "Text";
    }

    set templateType(tType) {
        this.emailTemplate.isHtml = tType && tType.toUpperCase() === "HTML";
    }

    // region : event handlers

    public ngOnInit(): void {
        this.errorMessage = "";
        this.errors = [];
        this.emailTemplate = new EmailTemplate();
        this.formInvalid = false;
    }

    public onHandleProcessing(isProcessing: boolean): void {
        this.isProcessing = isProcessing;
    }

    public onSubmit(): void {
        swal({
            title: "Are you sure?",
            text: "You are about to modify an email template for the system!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        }).then(() => {
            this.saveEmailTemplate();
        }, (dismiss) => { });
    }

    public saveEmailTemplate(): void {
        this.isProcessing = true;
        this.emailTemplateService
            .Save(this.emailTemplate)
            .subscribe((response) => {
                    swal(
                        "Done!",
                        "Your request has been completed successfully!",
                        "success");
                    this.saveSuccessful.emit();
                },
                (error) => {
                    swal(
                        "Failed!",
                        "Failed to process your request! Please try later...",
                        "error"
                    );
                });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/userHome/emailTemplates/emailTemplateEdit/emailTemplateEdit.component.ts